import { render, staticRenderFns } from "./detailMessage.vue?vue&type=template&id=b9019682&scoped=true&"
import script from "./detailMessage.vue?vue&type=script&lang=js&"
export * from "./detailMessage.vue?vue&type=script&lang=js&"
import style0 from "./detailMessage.vue?vue&type=style&index=0&id=b9019682&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9019682",
  null
  
)

export default component.exports